import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { Row, Col } from 'react-materialize';
import moment from 'moment';

const NotificationListItem = (props) => {
    return (
        <>
            <span
                className="sixth-text-color right"
                style={{ position: 'absolute', right: '22px', zIndex: '999' }}
            >
                <Row>
                    <Col className="col s12" style={{ padding: 0 }}>
                        {moment(props.data.createdOn).fromNow()}
                    </Col>
                </Row>
            </span>
            <Link
                style={{ display: 'block' }}
                to={{ pathname: props.data.url, state: { data: props.data } }}
                onClick={(event) => {
                    if (props.onSelectChange) {
                        props.onSelectChange(event);
                    }
                }}
            >
                <span className="title sixth-text-color">{`${props.data.title}`}</span>
                <span className="truncate sixth-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-message-text" /> {props.data.messageText}
                </span>
            </Link>
        </>
    );
};

export default withRouter(withTranslation()(NotificationListItem));
